
import React from 'react';
import { connect } from 'react-redux';
import Navbar from '../../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../../_components/common/SideNavBar';
import AnalysisNavBar from '../../../../../../_components/common/AnalysisNavBar';


import { NavLink } from 'react-router-dom';
import { Collapse, Button } from 'reactstrap';

import Swal from 'sweetalert2';

import './index.css'
import CircularButtonGroup from '../../../../../../_components/common/CircularButtonGroup';
import ModalComponent from '../../../../../../_components/common/Modal';
import { orgAdminAction, saveModulePermissionsAction, VirtualTeamAction } from '../../../../../../_actions';

import virtualTeamIcon from '../../../../../../images/virtualTeamIcon.png';

class TeamMembers extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            teamLeaderState: 0,
            onShowAddMemebers: false,
            onClickRadioState: false,
            disableSaveButton: false,
            radioClicked: false,
            updateModalState: false,
            teamid: 'null',
            addMembersState: [],
            navData: [{
                navName: "Analyze",
                link: `/organisation/${props.match.params.id}/user`
            },
            {
                navName: "Org Admin Area",
                link: `/organisation/${props.match.params.id}/org-admin`
            },
            {
                navName: "Super Admin Area",
                link: `/organisation/${props.match.params.id}/super-admin`
            }],
            VirtualTeamSidebarNav: {
                sideNavCatagoryData: [
                    {
                        name: 'Virtual Teams',
                        link: 'my-teams/manage-virtual-teams'
                    },
                    {
                        name: 'Virtual Team Members',
                        link: 'my-teams/virtual-teams/manage-members'
                    },
                    {
                        name: 'Share Virtual Teams',
                        link: 'my-teams/virtual-teams/manage-share'
                    },
                ]
            },
            select_data: [],
            tableData: [
                {
                    name: 'Amit Anand',
                    email: 'amit@jungle-ventures.com',
                    id: '123',
                    is_team_leader: true,
                    active: true
                },
                {
                    name: 'Aniket Chakraborty',
                    email: 'aniket.chakraborty_943@arpitha.com',
                    id: '456',
                    is_team_leader: false,
                    active: true

                },
                {
                    name: 'Anzar Ahmed',
                    email: 'anzar.ahmed_933@arpitha.com',
                    id: '789',
                    is_team_leader: false,
                    active: true

                },
                {
                    name: 'A Vinay Kumar',
                    email: 'vinay.anantha_924@arpitha.com',
                    id: '135',
                    is_team_leader: false,
                    active: true

                },
                {
                    name: 'Chirayu Wadke',
                    email: 'chirayuwadke@gmail.com',
                    id: '246',
                    is_team_leader: false,
                    active: true

                },
                {
                    name: 'Hansveen Kaur',
                    email: 'hansveen.kaur_952@arpitha.com',
                    id: '468',
                    is_team_leader: false,
                    active: true

                }
            ],
            tempData: [],
            sharedWith: [],
            tempData_available: [],
            teamName: '',
            showSharePopup: false,
            shareWithState: ''
        }
    }

    componentDidUpdate(prevProps) {

        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }

        if(prevProps.member_list_data !== this.props.member_list_data) {
            this.props.member_list_data.map(val => {
                if(val.is_team_leader) {
                    this.setState({
                        teamLeaderState: val.id
                    })
                }
            })
        }

        if(prevProps.match.params.teamid !== this.props.match.params.teamid) {
            if(this.props.match.params.teamid !== 'null' ){
                const {dispatch} = this.props;

                let postObj_teamId = {
                    "team_id":+this.props.match.params.teamid
                }

                let postObj_listapi = {
                    "analytics_org_id":+this.props.match.params.id
                }

                
        
        
                dispatch(VirtualTeamAction.memberList(postObj_teamId, (dataFromApi) => {
                    dispatch(VirtualTeamAction.listApi(postObj_listapi, (data_all_members) => {
                        let tempData = []
                        let tempData_available = []
                        let team_members = [...dataFromApi.data.team_members]
                        let team_all_members = [...data_all_members.data.members.order_by_name]
            
                        function comparer(otherArray){
                            return function(current){
                            return otherArray.filter(function(other){
                                return other.user_id == current.participant__id
                            }).length == 0;
                            }
                        }
                        
                        var difference = team_all_members.filter(comparer(team_members));


                        difference.map(val => {
                            let obj = {
                                name: val.participant__full_name,
                                email: val.participant__email,
                                id: val.participant__id,
                                user_id: val.participant__id,
                                is_team_leader: val.is_team_leader,
                                // active: true
                            }
        
                            tempData_available.push(obj)
                        })

                        team_members.map(val => {
                            let obj = {
                                name: val.user__full_name,
                                email: val.user__email,
                                id: val.id,
                                user_id: val.user_id,
                                is_team_leader: val.is_team_leader,
                                active: true
                            }
        
                            tempData.push(obj)
                        })
                        
                        
            
                        this.setState({
                            tempData,
                            tempData_available
                        }, () => {
                            let pathName = this.props.location.pathname.split('/');                

                            this.state.select_data.map(
                                (data, i) => {
                                    if (+pathName[pathName.length - 1] === data.id) {
                                        this.setState({
                                            teamName: data.name,
                                            teamid: pathName[pathName.length - 1]
                                        })
                                    }
                                }
                            )

                        })
                    }))
        
                }))

                

            }
        }
    }

    componentDidMount() {
        let pathName = this.props.location.pathname.split('/');
        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse === '' || (+this.props.saveTeamDetailsResponse.orgId !== +this.props.match.params.id)) {
            const fd = {
                "pa_user_email": localStorage.getItem('user_email'),
                "organisation_id": +this.props.match.params.id
            }
            this.props.dispatch(orgAdminAction.getModulePermissionListHandler(fd, () => {
                this.props.dispatch(saveModulePermissionsAction.saveModulePermissionsHandler(this.props.getModulePermissionsListResponse))
                this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
            }))
        }
        else {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'Virtual Teams') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        let postObj_teamList = {
            "analytics_org_id":+this.props.match.params.id
        }

        const { dispatch } = this.props;

        dispatch(VirtualTeamAction.virtualListApi(postObj_teamList, (reloaded) => {
            let select_data = []

            if(reloaded.data !== undefined) {
                if(reloaded.data.team !== undefined) {
                    reloaded.data.team.map(val => {
                        let select_obj = {
                            name: val.team_name,
                            id: val.id
                        }
                        
                        select_data.push(select_obj)
                    })
                }
            }

            if (this.props.match.params.teamid == undefined && select_data.length) {
                this.props.history.push(`/organisation/${this.props.match.params.id}/my-teams/virtual-teams/manage-members/${select_data[0].id}`)
            }
            
            this.setState({
                select_data
            }, () => {
                this.state.select_data.map(
                    (data, i) => {
                        if (+pathName[pathName.length - 1] === data.id) {
                            this.setState({
                                teamName: data.name,
                                teamid: pathName[pathName.length - 1]
                            })
                        }
                    }
                )
            })
        }))

        let postObj_teamId = {
            "team_id":+this.props.match.params.teamid
        }

        let postObj_listapi = {
            "analytics_org_id":+this.props.match.params.id
        }

        let postObj_sharedWith = {
            "team_id":+this.props.match.params.teamid
        }


        if(this.props.match.params.teamid) {
            dispatch(VirtualTeamAction.sharedWith(postObj_sharedWith, (sharedWith_data) => {
                sharedWith_data.data.shared_with.map(val => {
                    val["value"] = false
                })
                this.setState({
                    sharedWith: sharedWith_data.data.shared_with
                })
            }))
    
    
            dispatch(VirtualTeamAction.memberList(postObj_teamId, (dataFromApi) => {
                dispatch(VirtualTeamAction.listApi(postObj_listapi, (data_all_members) => {
                    let tempData = []
                    let tempData_available = []
                    let team_members = [...dataFromApi.data.team_members]
                    let team_all_members = [...data_all_members.data.members.order_by_name]
        
                    function comparer(otherArray){
                        return function(current){
                          return otherArray.filter(function(other){
                            return other.user_id == current.participant__id
                          }).length == 0;
                        }
                    }
                      
                    var difference = team_all_members.filter(comparer(team_members));
    
    
                    difference.map(val => {
                        let obj = {
                            name: val.participant__full_name,
                            email: val.participant__email,
                            id: val.participant__id,
                            user_id: val.participant__id,
                            is_team_leader: val.is_team_leader,
                            // active: true
                        }
    
                        tempData_available.push(obj)
                    })
    
                    team_members.map(val => {
                        let obj = {
                            name: val.user__full_name,
                            email: val.user__email,
                            id: val.id,
                            user_id: val.user_id,
                            is_team_leader: val.is_team_leader,
                            active: true
                        }
    
                        tempData.push(obj)
                    })
                    
        
                    this.setState({
                        tempData,
                        tempData_available
                    })
                }))
    
            }))
        }
        
        
    }

    onChangeAddMembers = (event, id) => {
        let addMembers = [...this.state.addMembersState];
        if (event.target.checked === false) {
            for (let i = 0; i < addMembers.length; i++) {
                if (id === addMembers[i]) {
                    addMembers.splice(i, 1);
                }
            }
            this.setState({ addMembersState: addMembers })
        }
        else {
            let addMembers = [...this.state.addMembersState];
            addMembers.push(id);
            this.setState({ addMembersState: addMembers })
        }
    }

    onClickCheckBox = (event, id) => {
        let tempData = this.state.tempData
        let count = 0;
        for (let i = 0; i < tempData.length; i++) {
            if (tempData[i].id === id) {
                tempData[i].active = event.target.checked
                if (event.target.checked === false) {
                    if (tempData[i].is_team_leader === true) {
                        tempData[i].is_team_leader = false
                        this.setState({ radioClicked: false })
                    }
                }
            }
        }

        let noTeamLeader = true

        for (let i = 0; i < tempData.length; i++) {
            const element = tempData[i];
            if(element.is_team_leader) {
                noTeamLeader = false
            }
        }
        this.setState({ onClickRadioState: !noTeamLeader, tempData: tempData })
    }

    isDataChanged = (data) => {
        let count = 0;
        let temp = 0;
        const { tempData } = this.state;
        for (let i = 0; i < tempData.length; i++) {
            if (tempData[i].is_team_leader !== data[i].is_team_leader) {
                count = count + 1;
            }
            if (tempData[i].active !== data[i].active) {
                count = count + 1;
            }
            temp = data[i].active === true ? temp + 1 : temp;
        }
        temp < 2 ? this.setState({ disableSaveButton: true }) : this.setState({ disableSaveButton: false })
        return count > 0 ? true : false;
    }


    onClickRadio = (event, id) => {
        let tempData = this.state.tempData
        for (let i = 0; i < tempData.length; i++) {
            if (tempData[i].id === id) {
                tempData[i].is_team_leader = true
                tempData[i].active = true
            }
            else {
                tempData[i].is_team_leader = false
            }
        }
        this.setState({ onClickRadioState: event.target.checked, tempData: tempData, radioClicked: true })
    }

    onClickResponseHandler(type) {
        if(type === 'Save') {
            const {dispatch} = this.props;

            let activeTeamId = []
            let teamLeader = this.state.teamLeaderState
            let tempData = [...this.state.tempData]

            tempData.map(val => {
                if(!val.active){
                    activeTeamId.push(val.id)
                }
                if(val.is_team_leader) {
                    teamLeader = val.id
                }
            })

            let postObj_update = {}

            if(this.state.teamLeaderState === teamLeader) {
                postObj_update = {
                    "team_id":+this.props.match.params.teamid,
                    "team_member_id":activeTeamId
                }
            }else {
                postObj_update = {
                    "team_id":+this.props.match.params.teamid,
                    "team_leader_id":teamLeader,
                    "team_member_id":activeTeamId
                }
            }

            let postObj_teamId = {
                "team_id":+this.props.match.params.teamid
            }
    
            let postObj_listapi = {
                "analytics_org_id":+this.props.match.params.id
            }

            dispatch(VirtualTeamAction.updateMember(postObj_update, (updated_data_api) => {

                let swalText = ``;

                updated_data_api.data.update_status.map(val => {
                    swalText = `${swalText} <p>${val.message}</p>`
                })


                Swal({
                    html: swalText,
                    type: 'success',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                })
                dispatch(VirtualTeamAction.memberList(postObj_teamId, (dataFromApi) => {
                    dispatch(VirtualTeamAction.listApi(postObj_listapi, (data_all_members) => {
                        let tempData = []
                        let tempData_available = []
                        let team_members = [...dataFromApi.data.team_members]
                        let team_all_members = [...data_all_members.data.members.order_by_name]
            
                        function comparer(otherArray){
                            return function(current){
                              return otherArray.filter(function(other){
                                return other.user_id == current.participant__id
                              }).length == 0;
                            }
                        }
                          
                        var difference = team_all_members.filter(comparer(team_members));
        
        
                        difference.map(val => {
                            let obj = {
                                name: val.participant__full_name,
                                email: val.participant__email,
                                id: val.participant__id,
                                user_id: val.participant__id,
                                is_team_leader: val.is_team_leader,
                                // active: true
                            }
        
                            tempData_available.push(obj)
                        })
        
                        team_members.map(val => {
                            let obj = {
                                name: val.user__full_name,
                                email: val.user__email,
                                id: val.id,
                                user_id: val.user_id,
                                is_team_leader: val.is_team_leader,
                                active: true
                            }
        
                            tempData.push(obj)
                        })
                        
            
                        this.setState({
                            tempData,
                            tempData_available,
                            onClickRadioState: !this.state.onClickRadioState
                        })
                    }))
        
                }))
            }))

        }
        this.setState({ updateModalState: false })
    }

    onChangeTeam = (ev) => {
        this.setState({
            teamid: ev.target.value
        })
        this.props.history.push(`/organisation/${this.props.match.params.id}/my-teams/virtual-teams/manage-members/${ev.target.value}`);
    }

    addNewMember = () => {
        const {dispatch} = this.props;

        let postObj_add = {
            "analytics_organisation":+this.props.match.params.id,
            "team_id":+this.props.match.params.teamid,
            "team_member_id":this.state.addMembersState
        }

        let postObj_teamId = {
            "team_id":+this.props.match.params.teamid            
        }

        dispatch(VirtualTeamAction.addMember(postObj_add, dataFromApi_AddMem => {
            let postObj_teamId = {
                "team_id":+this.props.match.params.teamid
            }

            let postObj_listapi = {
                "analytics_org_id":+this.props.match.params.id
            }
    
    
            dispatch(VirtualTeamAction.memberList(postObj_teamId, (dataFromApi) => {
                dispatch(VirtualTeamAction.listApi(postObj_listapi, (data_all_members) => {
                    let tempData = []
                    let tempData_available = []
                    let team_members = [...dataFromApi.data.team_members]
                    let team_all_members = [...data_all_members.data.members.order_by_name]
        
                    function comparer(otherArray){
                        return function(current){
                          return otherArray.filter(function(other){
                            return other.user_id == current.participant__id
                          }).length == 0;
                        }
                    }
                      
                    var difference = team_all_members.filter(comparer(team_members));


                    difference.map(val => {
                        let obj = {
                            name: val.participant__full_name,
                            email: val.participant__email,
                            id: val.participant__id,
                            user_id: val.participant__id,
                            is_team_leader: val.is_team_leader,
                            // active: true
                        }
    
                        tempData_available.push(obj)
                    })

                    team_members.map(val => {
                        let obj = {
                            name: val.user__full_name,
                            email: val.user__email,
                            id: val.id,
                            user_id: val.user_id,
                            is_team_leader: val.is_team_leader,
                            active: true
                        }
    
                        tempData.push(obj)
                    })
                    
        
                    this.setState({
                        tempData,
                        tempData_available,
                        onShowAddMemebers: false
                    })
                }))
    
            }))
        }))
    }

    checkIfEmailProper() {
        return !/^[A-Za-z0-9](([_\.\+\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\+\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/.test(this.state.shareWithState)
    }

    addNewSharedWith() {
        const {dispatch} = this.props;

        let postObj_shareTeam = {
            "organisation":+this.props.match.params.id,
            "team_id" : +this.props.match.params.teamid,
            "email_id": [this.state.shareWithState]
        }

        let postObj_sharedWith = {
            "team_id":+this.props.match.params.teamid
        }

        dispatch(VirtualTeamAction.shareTeam(postObj_shareTeam, (shareTeam_data) => {
            let swalHtml = ``
            shareTeam_data.data.message.map(val => {
                if(val.email !== undefined && val.message !== undefined) {
                    swalHtml = `${swalHtml} <p>${val.email} : ${val.message}</p>`
                }else if(val.success_message !== undefined) {
                    swalHtml = `${swalHtml} <p>${val.success_message}</p>`
                }
            })
            Swal({
                html: swalHtml,
                type: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            })
            dispatch(VirtualTeamAction.sharedWith(postObj_sharedWith, (sharedWith_data) => {
                sharedWith_data.data.shared_with.map(val => {
                    val["value"] = false
                })
                this.setState({
                    sharedWith: sharedWith_data.data.shared_with
                })
            }))
        }))
    }

    render() {
        const { navData, select_data } = this.state;
        const { member_list_data, member_list_error, member_list_loading } = this.props;
        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={this.state.VirtualTeamSidebarNav.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="">
                        <AnalysisNavBar
                            analyticsData={this.props.saveModulePermissionsResponse}
                            orgId={this.props.match.params.id}
                            analyticsType={'people'} />
                        <div className="d-flex justify-content-start drop-down-container my-3"  style={{margin: 'auto', width: 400}}>
                            <h6 className="d-flex justify-content-start align-items-center mb-0 px-2 " style={{flex: 2}}>Manage Members for Team</h6>
                            <select
                                value={this.state.teamid}
                                className="drop-down form-control"
                                onChange={this.onChangeTeam}
                                style={{flex: 1}}
                            >
                                {
                                    select_data.map((val, key) => {
                                        return (
                                            <option key={key} value={val.id} >{val.name}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>

                        
                        <div style={{ margin: ' 0px auto', textAlign: 'center', padding: '40px 0px', minWidth: '800px' }}>
                            {
                                (!member_list_error && !member_list_loading && this.state.tempData.length && this.state.teamName.length) ?
                                    <Collapse
                                        isOpen={this.state.tempData.length && this.state.teamName.length ? true : false}
                                    >
                                        <div style={{ display: 'inline-block' }}>
                                            <div >
                                                <div style={{ height: '40px', lineHeight: '40px', color: 'white', textAlign: 'left', paddingLeft: '15px', backgroundColor: '#845C27' }}>
                                                    {this.state.teamName}'s Team
                                                </div>
                                            </div>
                                                <table style={{ borderCollapse: 'collapse', display: 'block', overflowY: 'scroll', maxHeight: '323px' }}>
                                                    <tbody>
                                                        {
                                                            this.state.tempData.map(
                                                                (data, i) => {
                                                                    return <tr key={i} style={{ background: 'rgb(243, 243, 243)', borderTop: '3px solid #fff', padding: '5px 15px', textAlign: 'left' }} >
                                                                        <td style={{ fontStyle: 'italic', 'padding': ' 5px 15px', textAlign: 'left', fontSize: 12, fontWeight: 'bold' }}>
                                                                            <span className={data.is_team_leader === true ? 'text-success' : ''}>{data.name ? data.name : 'No Name'}</span>
                                                                        </td>
                                                                        <td style={{ fontStyle: 'italic', 'padding': ' 5px 15px', textAlign: 'left', fontSize: 12 }}>
                                                                            <span>{data.email}</span>
                                                                        </td>
                                                                        <td className="d-flex">
                                                                            <div style={{padding: '0 10px'}}>
                                                                                <input checked={data.is_team_leader} onChange={(event) => this.onClickRadio(event, data.id)} disabled={this.state.onShowAddMemebers} type="radio" name="radio" id={data.id} value="on" />
                                                                            </div>
                                                                            <div style={{padding: '0 10px'}}>
                                                                                <input checked={data.active} onChange={(event) => this.onClickCheckBox(event, data.id)} type="checkbox" id={data.id} disabled={this.state.onShowAddMemebers} value="on" />
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            )
                                                        }
                                                        {
                                                            this.state.sharedWith.length ?
                                                                <tr style={{background: '#c28b58',  borderTop: '6px solid #fff'}}>
                                                                    <td colspan="3" style={{fontSize: 12, textAlign: 'left', padding: '0.2rem 1rem', color: 'white', fontStyle: 'italic'}}>Team details shared with</td>
                                                                </tr>
                                                            :
                                                                null
                                                        }
                                                        {
                                                            this.state.sharedWith.map(val => {
                                                                return (
                                                                    <tr key={val.id} style={{ background: 'rgb(243, 243, 243)', borderTop: '3px solid #fff', padding: '5px 15px', textAlign: 'left' }}>
                                                                        <td style={{ fontStyle: 'italic', 'padding': ' 5px 15px', textAlign: 'left', fontSize: 12, fontWeight: 'bold' }}>
                                                                            <p className="font-italic mb-0">{val.shared_to_user__full_name ? val.shared_to_user__full_name : 'No Name'}</p>
                                                                        </td>
                                                                        <td style={{ fontStyle: 'italic', 'padding': ' 5px 15px', textAlign: 'left', fontSize: 12 }}>
                                                                            <p className="font-italic mb-0">{val.shared_to_user__email}</p>
                                                                        </td>
                                                                        <td>
                                                                            {/* <input type="checkbox" checked={val.value} onClick={(e) => this.selectShare(e, 'single',  val)} /> */}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            <div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
                                                <div className="col-5 d-flex flex-row  align-items-center">
                                                    <CircularButtonGroup buttonGroupData={[{
                                                        img: virtualTeamIcon,
                                                        link: `/organisation/${this.props.match.params.id}/my-teams/manage-virtual-teams`,
                                                        id: 3,
                                                        name: "Virtual Team",
                                                        tooltip_id: 3
                                                    },]} swotCatagory={this.props.match.params.id} textAlign={'start'} singleButton={false} />
                                                    

                                                </div>
                                                <div className="d-flex">
                                                    <div className="px-1">
                                                        {
                                                            (this.state.onClickRadioState === false) &&
                                                            <button onClick={() => this.setState({ onShowAddMemebers: !this.state.onShowAddMemebers })} style={{ backgroundColor: this.state.onShowAddMemebers ? '#AC7737' : '#FCD095', }} className="btn btn-sm "><small>ADD</small></button>
                                                        }

                                                        {
                                                            (this.state.onClickRadioState === true) &&
                                                            <button disabled={this.state.disableSaveButton} onClick={() => this.setState({ updateModalState: true })} style={{ backgroundColor: '#AC7737' }} className="text-white btn btn-sm "><small>SAVE</small></button>
                                                        }
                                                    </div>

                                                    {/* <div className="px-1">
                                                        <NavLink to={`/organisation/${this.props.match.params.id}/my-teams/virtual-teams/manage-share/${this.state.teamid}`} style={{ backgroundColor: '#FCD095', color: '#000' }} className="btn btn-sm "><small>SHARE</small></NavLink>
                                                    </div> */}

                                                    <div className="px-1">
                                                        <Button color="primary" style={{ backgroundColor: '#FCD095', color: '#000',border: 'none' }} onClick={() => this.setState({showSharePopup: !this.state.showSharePopup})} className="btn btn-sm"><small>SHARE</small></Button>
                                                    </div>

                                                    
                                                    

                                                    {
                                                        this.state.updateModalState === true &&
                                                        <ModalComponent
                                                            showModal={this.state.updateModalState}
                                                            heading="Update Team"
                                                            htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 ">
                                                        <p className="">Are you sure you want to update Team  <b>Anshu's Team ?</b></span>`}
                                                            footerNonSubmitButton={[{
                                                                'buttonName': 'Save',
                                                            }, {
                                                                'buttonName': 'Cancel',
                                                            }]}
                                                            responseHandler={(type) => this.onClickResponseHandler(type)}
                                                        />
                                                    }

                                                </div>
                                                <div className="w-100">
                                                    <Collapse
                                                        isOpen={this.state.showSharePopup}
                                                    >
                                                        <div className="float-right d-flex justify-content-center align-items-center" style={{fontSize: 14}}>
                                                            <input type="text" placeholder="sampath@arpitha.com" onChange={(e) => this.setState({shareWithState: e.target.value})} value={this.state.shareWithState} />
                                                            <Button disabled={this.checkIfEmailProper()} style={{background: 'transparent', color: 'black',border: 0}} onClick={() => this.addNewSharedWith()}>
                                                                <i className="fa fa-caret-right px-2" style={{fontSize: '2rem'}}></i>
                                                            </Button>
                                                        </div>
                                                    </Collapse>
                                                </div>
                                            </div>
                                            
                                            {
                                                this.state.onShowAddMemebers === true &&
                                                    <div className="" style={{ float: "right" }}>
                                                        <div style={{ border: ' 1px solid black', marginTop: '2px', width: '300px', maxHeight: '250px', overflowY: 'scroll', padding: '0px' }}>
                                                            <table>
                                                                <tbody>
                                                                    {
                                                                        this.state.tempData_available.map(
                                                                            (data, i) => {
                                                                                return <tr key={i}>
                                                                                    <td className="text-left pl-3">
                                                                                        <label className="font-italic cursor-pointer mb-0" style={{opacity: '0.6', fontSize: 12}}>
                                                                                            <input onChange={(event) => this.onChangeAddMembers(event, data.id)} type="checkbox" id={data.id} value="on" />
                                                                                            <span className="pl-4">{data.name ? data.name : data.email}</span>
                                                                                        </label>
                                                                                    </td>

                                                                                </tr>
                                                                            }
                                                                        )
                                                                    }

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="d-flex flex-row justify-content-end my-2">
                                                            <div className="mx-1 ">
                                                                <button disabled={this.state.addMembersState.length === 0} onClick={() => this.addNewMember()} style={{ backgroundColor: '#AC7737' }} className="btn btn-sm hello">+</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                        </div>
                                    </Collapse>
                                :
                                    member_list_error ?
                                        <p className="text-center mt-4">Un-recognised Error Occured! Please Try again!</p>
                                    :
                                        <i className="fa fa-spinner fa-spin"></i>
                            }
                            

                        </div>

                    </div>
                </ div>
            </div >


        );
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;
    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const {team_listMain_error, team_listMain_loading} = state.virtualTeamListMain;
    const team_listMain_data = (!team_listMain_error && !team_listMain_loading) ? state.virtualTeamListMain.team_listMain_data.data.team : []


    const {member_list_error, member_list_loading} = state.virtualMemberList;
    const member_list_data = (!member_list_error && !member_list_loading) ? state.virtualMemberList.member_list_data.data.team_members : [];
         //Header Permission
         const { headPerLoading } = state.headerPermissionReducer
         const headPerLoadingError = state.headerPermissionReducer.error
         const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

         const singleValidatorResponse = state.singleValidatorReducer.data;


    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,

        team_listMain_data,

        member_list_data,
        member_list_error,
        member_list_loading,

        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,

        singleValidatorResponse

    }
}

export default connect(mapStateToProps)(TeamMembers)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/VirtualTeams/TeamMembers/index.js